<template>
  <el-dialog title="系统公告" width="50%" :visible.sync="show" :before-close="handleClose" :close-on-click-modal="false" :append-to-body="true">
    <div class="form-content" id="form-content">
      <el-row class="notice-title"> {{ form.subject }}</el-row>
      <div class="content" v-html="form.content"></div>
      <!-- <el-row style="height:auto">
        <el-col :span="12" class="notice-col">编制人：{{ form.owner }}</el-col>
        <el-col :span="12" class="notice-col"
          >编制日期：{{ form.createTime }}</el-col
        >
      </el-row> -->
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      pWidth: 0
    }
  },
  // created() {
  //   this.pWidth = document.body.offsetWidth / 2;
  // },
  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.notice-title {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
}
.notice-body {
  height: 200px;
  max-height: 500px;
  padding: 35px;
  font-size: 16px;
}
.notice-col {
  height: 50px;
  padding-left: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.form-content >>> p {
  width: 100% !important;
}
.form-content >>> img {
  width: 100% !important;
}
</style>
